export const OTHER_ADDRESS_TYPE_ID = 6